import React, { useEffect, createElement } from 'react';
export function CookieScriptLoader() {
  useEffect(() => {
    // Create script element
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.charset = 'UTF-8';
    script.src = '//cdn.cookie-script.com/s/cf347cbe0925746e691604f500ce9734.js';
    script.async = true;
    // Append to document body
    document.body.appendChild(script);
    // Clean up function to remove script when component unmounts
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []); // Empty dependency array ensures this runs once on mount
  // This component doesn't render anything
  return null;
}